import type { CSSProperties } from 'react';
import {
  Outer,
  OuterSticky,
  ImageContainer,
  Img,
  Placeholder,
  Overlay,
  BadgeContainer,
  DefaultBadge,
} from './SideImage.styles';
import type { SideImageProps } from './SideImage.types';

function SideImageBase({
  src,
  alt = '',
  overlayContent,
  badge,
  mobileHeight,
  desktopHeight,
  sticky = true,
}: SideImageProps) {
  const WrapperEl = sticky ? OuterSticky : Outer;

  const cssVars = {
    ...(mobileHeight ? { '--side-image-mobile-height': mobileHeight } : {}),
    ...(desktopHeight ? { '--side-image-desktop-height': desktopHeight } : {}),
  } as CSSProperties;

  return (
    <WrapperEl>
      <ImageContainer style={cssVars}>
        {src ? <Img src={src} alt={alt} /> : <Placeholder />}
        {overlayContent && <Overlay>{overlayContent}</Overlay>}
        {badge && <BadgeContainer>{badge}</BadgeContainer>}
      </ImageContainer>
    </WrapperEl>
  );
}

export const SideImage = Object.assign(SideImageBase, {
  Badge: DefaultBadge,
});
